import type { IModularBenefitMessages } from '@ben/shared/types/columbia';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import Prices from '../prices/prices';
import { SectionContainer } from './styles';
import type { PricesForm, RateTableForm, StepsForm } from './types';

interface PricesElementProps {
  form: PricesForm;
  stepsForm?: StepsForm;
  rateTableForm?: RateTableForm;
  errors: Record<string, boolean>;
  warnings: IModularBenefitMessages;
  successes: IModularBenefitMessages;
}

const PricesElement = ({
  form,
  stepsForm,
  rateTableForm,
  errors,
  warnings,
  successes,
}: PricesElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <Prices
        errors={errors}
        warnings={warnings}
        successes={successes}
        stepsControl={stepsForm?.control}
        rateTableControl={rateTableForm?.control}
      />
    </FormProvider>
  </SectionContainer>
);

export default memo(PricesElement);
